<template>
  <v-tooltip top :disable="disableTooltip">
    <template v-slot:activator="{ on }">
      <span
        v-on="on"
        :class="`compact-chip ${color} lighten-4 ${textColor || color}--text text--darken-2`"
      >
        {{ label }}
      </span>
    </template>
    <span v-if="tooltip">{{ tooltip }}</span>
    <div v-else>
      <slot name="tooltip"></slot>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "compact-chip",
  props: {
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: "blue",
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: "top",
    },
    textColor: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "grey",
    },
    disableTooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.compact-chip {
  font-size: 11px;
  line-height: 12px;
  padding: 2px 4px 0px 4px;
  border-radius: 4px;
  font-weight: 500;
  margin-top: auto;
  margin-left: 4px;
}
</style>
